<template>
  <div class="main-box" ref="container">
    <SearchForm v-model="orderID" placeholder="请输入订单号"></SearchForm>
    <isEmpty v-if="orderList.length === 0">
      <div slot="desc" class="is-empty_desc">
        <div class="is-empty_desc-title">
          充电桩暂时没有接到订单
        </div>
        <!--        <div class="is-empty_descript">-->
        <!--          <p>请点击下方 ’添加充电站‘ 按钮</p>-->
        <!--          <p>开始您的运营之旅吧！</p>-->
        <!--        </div>-->
      </div>
    </isEmpty>
    <div class="content" v-else>
      <div class="content-title">全部订单<span>{{ total }}</span></div>
      <mu-load-more
          @refresh="refresh"
          :refreshing="refreshing"
          :loaded-all="loaded_all"
          :loading="loading"
          @load="load"
      >
        <div class="list-item"
             v-for="(item, index) in orderList"
             @click="orderDetailPush(item)"
             :key="`list-item_${index}`">
          <div class="header-info">
            <div class="no text-overflow">
              订单编号：{{ item.ordernumber }}
            </div>
            <div class="state" :class="{'finish': item.chargeStatus === '充电完成'}">{{ item.chargeStatus }}</div>
          </div>
          <div class="data-box">
            <div class="data-item">
              <div class="before">开始时间</div>
              <div class="after">{{ item.starttime || '未知' }}</div>
            </div>
            <div class="data-item">
              <div class="before">预计结束时间</div>
              <div class="after">{{ item.realEndTime || '未知' }}</div>
            </div>
            <div class="data-item">
              <div class="before">电站名称</div>
              <div class="after">{{ item.pileName || '-' }}</div>
            </div>
            <div class="data-item">
              <div class="before">充电桩编码</div>
              <div class="after">{{ item.parkId || '未知' }}</div>
            </div>
            <div class="data-item">
              <div class="before">端口名称</div>
              <div class="after">{{ item.portName || '未知' }}</div>
            </div>
            <div class="data-item" v-if="item.chargeStatus === '充电完成'">
              <div class="before">已充电量</div>
              <div class="after">{{
                  item.consumePower == null ? 0 : handleControlNumber(item.consumePower || 0, 2)
                }}度
              </div>
            </div>
            <div class="data-item" v-if="item.chargeStatus === '充电完成'">
              <div class="before">充电金额</div>
              <div class="after" style="color: #165DFF">{{ handleControlNumber(item.realTimeFee || 0, 2) }}元</div>
            </div>
            <div class="data-item">
              <div class="before">支付状态</div>
              <div class="after">{{item.orderstate}}</div>
            </div>
          </div>
        </div>
      </mu-load-more>
    </div>
    <choose ref="choose" v-on:chooseDate="shaixuan"></choose>
    <refund ref="refund"></refund>
    <changeport ref="changeport"></changeport>
  </div>
</template>

<script>
import changeport from "@/components/global/changeport";
import refund from "@/components/global/refund";
import choose from "@/components/global/choose";
import {getOrderList} from "@/api/newApi";
import {Toast} from "vant";
import "vant/lib/toast/style/index";
import {digitUtil} from "@/utils/utils";

export default {
  data() {
    return {
      pages: 0,
      orderID: "",
      num: 1,
      loaded_all: false,
      refreshing: false,
      loading: false,
      back: {
        background:
            "url(" + require("../../../assets/image/minebackimg.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      },
      orderList: [],
      pageSize: 5,
      total: 0,
      choosedata: {
        plot: "",
        startTime: "",
        endTime: "",
        parkid: "",
        state: "",
      },
    };
  },
  components: {
    choose: choose,
    refund: refund,
    changeport: changeport,
  },
  watch: {
    orderID: function () {
      this.pages = 1;
      this.orderList = [];
      this.getList();
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.choosedata.parkid = this.$route.query.id;
    }
    this.getList();
  },
  methods: {
    handleControlNumber: digitUtil,
    showchoosediv() {
      this.$refs.choose.Showchoosediv();
    },
    shaixuan: function (somedata) {
      (this.choosedata.plot = somedata.xiaoquId),
          (this.choosedata.startTime = somedata.stime),
          (this.choosedata.endTime = somedata.etime),
          (this.choosedata.plot = somedata.xiaoquId),
          (this.choosedata.parki = somedata.parkid);
      this.choosedata.state = somedata.state;
      this.getList();
    },
    showrefunddiv(item) {
      // this.$refs.refund.Showrefunddiv(item);
      this.$router.push({
        path: "/admin/orderBackMoney",
        query: {
          ordernumber: item.ordernumber,
        },
      });
    },
    showchangeportdiv(item) {
      this.$router.push({
        path: "/admin/portChange",
        query: {
          ordernumber: item.ordernumber,
        },
      });
    },
    getList() {
      getOrderList({
        ordernumber: this.orderID,
        userOrNum: this.orderID,
        state: this.choosedata.state,
        pageNo: this.num,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.data != "") {
          if (res.message.code == 0) {
            this.total = res.data.total;
            this.pages = res.data.pages;
            res.data.records.forEach((item) => {
              this.orderList.push(item);
            });
            this.nolist = false;
            if (res.data.pages == this.num) {
              Toast("已加载全部数据");
              this.loaded_all = true;
            }
          }
        } else {
          this.orderList = [];
          Toast("暂无数据");
        }
      });
    },
    refresh() {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      setTimeout(() => {
        this.refreshing = false;
        this.num = 1;
        this.orderList = [];
        this.getList();
      }, 1000);
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.num += 1;
        if (this.num <= this.pages) {
          this.getList();
        }
      }, 2000);
    },
    //计算两个时间之间的时间差 多少天时分秒
    intervalTime(begin_time, end_time) {
      //年月日时分秒转换为时间戳
      let beginTime = new Date(begin_time).getTime() / 1000;
      let endTime = new Date(end_time).getTime() / 1000;
      var starttime = "";
      var endtime = "";
      if (beginTime < endTime) {
        starttime = beginTime;
        endtime = endTime;
      } else {
        starttime = endTime;
        endtime = beginTime;
      }
      //计算天数
      var timediff = endtime - starttime;
      var days = parseInt(timediff / 86400);
      //计算小时数
      var remain = timediff % 86400;
      var hours = parseInt(remain / 3600);
      //计算分钟数
      var remain = remain % 3600;
      var mins = parseInt(remain / 60);
      var res =
          (days ? days + "天" : "") +
          (hours ? hours + "小时" : "") +
          (mins ? mins + "分" : "--");
      return res;
    },
    orderDetailPush(item) {
      this.$router.push({
        path: "/admin/orderDetail",
        query: {
          orderNumber: item.ordernumber,
          parkId: item.parkId
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.main-box {
  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;

  .content {
    padding: 0 $divPadding;

    .content-title {
      padding: 0.3rem 0;
      font-size: $fontSize_14;
      color: #666666;

      span {
        color: #3D3D3D;
        margin-left: 0.1rem;
        font-weight: bold;
      }
    }

    .list-item {
      margin-bottom: 0.3rem;
      border-radius: $borderRadius;
      background-color: white;
      padding: $divPadding;

      .header-info {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0.3rem;
        border-bottom: 1px solid #ECECEC;

        .no {
          flex: 1;
          align-self: center;
          color: #444444;
          font-size: $fontSize_14;
          padding-right: 0.3rem;
        }

        .state {
          align-self: center;
          font-size: $fontSize_12;
          color: #FF7D00;
        }

        .finish {
          color: #3EB03C;
        }

      }

      .data-box {
        margin-top: 0.3rem;

        .data-item {
          display: flex;
          justify-content: space-between;
          padding: 0.1rem 0;
          font-size: $fontSize_12;

          .before {
            color: #999999;
          }

          .after {
            color: #444444;

          }
        }
      }
    }
  }

  .info-box-length {
    margin: 0.2778rem 0.3467rem;
    font-size: 0.3733rem;
    color: #000000;
  }

  .use-box {
    margin: 0.2667rem 0;
  }

  .cardContent {
    .order-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f2f5fa;

      .title {
        text-align: left;
        display: flex;
        align-items: center;
        flex: 1;
        overflow: hidden;

        img {
          height: 0.4rem;
          width: 0.6133rem;
          margin-right: 0.2667rem;
        }

        .address {
          font-size: 0.4267rem;
          font-weight: 600;
          color: #000;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .price {
        margin-left: 0.32rem;
        color: #fa541c;
        font-weight: 600;
        font-size: 0.5333rem;

        span {
          font-weight: 400;
          font-size: 0.3467rem;
          margin-right: 0.08rem;
        }
      }
    }

    .content-info {
      display: flex;
      align-items: center;
      margin: 0.32rem 0;
      font-size: 0.3267rem;

      .info-charge {
        height: 0.32rem;
        margin-right: 0.2133rem;
      }

      .info-line {
        height: 0.3733rem;
        width: 1px;
        background-color: #000000;
        margin: 0 0.32rem;
      }

      .info-time {
        height: 0.3733rem;
        margin-right: 0.2133rem;
      }
    }

    .content-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.3467rem;
      color: #666666;
      padding-bottom: 0.2667rem;
      border-bottom: 1px solid #f2f5fa;

      .order-num {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .order-status {
        width: 2.667rem;
        text-align: right;
        margin-left: 0.32rem;
        color: #e3b34d;

        .finish {
          color: #4764cf;
        }
      }
    }
  }

  .subButton {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.2667rem;

    .btn-item {
      margin-left: 0.2933rem;
      width: 1.8933rem;
      height: 0.7467rem;
      line-height: 0.7467rem;
      text-align: center;
      font-size: 0.32rem;
      background: #fff;
      border: 1px solid #134fc5;
      border-radius: 0.3467rem;
      color: #3961b2;
    }
  }
}
</style>
